import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {GradeService} from '../../apiModule1';

export const gradeResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: GradeService = inject(GradeService)) => {
  return service.apiGradeGet({}, 'body', false, {transferCache: false});
};
